import HomebaseComponentCreate from "./HomebaseComponentCreate";
import HomebaseComponentEdit from "./HomebaseComponentEdit";
import HomebaseComponentList from "./HomebaseComponentList";

export default {
  list: HomebaseComponentList,
  create: HomebaseComponentCreate,
  edit: HomebaseComponentEdit,
};
